<template>
  <fieldset>
    <legend class="form__label">{{ name }}</legend>
    <div v-for="option in options" :key="option.value" class="mr-32 my-8">
      <poppins-radio-button
        :id="`radio-${option.value}`"
        :data-test-id="option.value"
        :radioName="name"
        :labelName="option.label"
        :radioValue="option.value"
        :checked="selectedValue === option.value"
        @update:model-value="radioSelection"
      />
      <HelperText v-if="option.helperText" :text="option.helperText" class="ml-28 mt-4" />
    </div>
  </fieldset>
</template>

<script lang="ts">
import PoppinsRadioButton from '../radio_button/RadioButton.vue';
import HelperText from '../helper_text/HelperText.vue';
import helperStatus from '../../helpers/status';

export default {
  name: 'RadioButtonGroup',
  components: { PoppinsRadioButton, HelperText },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
      required: false,
    },
    defaultValue: {
      type: [String, Number],
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array as () => Array<{ value: string; label: string; helperText?: string }>,
      required: true,
    },
    status: {
      type: Number as () => helperStatus,
      default: helperStatus.Neutral,
    },
  },
  data() {
    return {
      selectedValue: this.modelValue !== undefined && this.modelValue !== '' ? this.modelValue : this.defaultValue || '',
    };
  },
  watch: {
    modelValue(newVal) {
      if (newVal === '') {
        this.selectedValue = '';
        return;
      }
      this.selectedValue = newVal !== undefined && newVal !== null ? newVal : this.defaultValue || '';
    },
  },
  mounted() {
    if (this.modelValue !== '' && this.modelValue !== undefined) {
      return;
    }
    const initialValue = this.selectedValue || this.defaultValue;
    if (!initialValue) {
      return;
    }
    this.$emit('update:modelValue', initialValue);
  },
  methods: {
    radioSelection(value: string | number): void {
      this.selectedValue = value;
      this.$emit('update:modelValue', value);
    },
  },
};
</script>
